import { wait } from '../async';

export const download = (
  blob: Blob,
  fileName: string,
  debounceTime?: number,
) => {
  const a = document.createElement('a');

  a.href = URL.createObjectURL(blob);
  a.download = fileName;

  wait(debounceTime).then(() => {
    a.click();

    URL.revokeObjectURL(a.href);

    a.remove();
  });
};
